import LogoIn from 'src/assets/images/LandingPage/marketDesign/layer_initial/badge_inside.png';
import LogoOut from 'src/assets/images/LandingPage/marketDesign/layer_initial/badge_outside.png';
import React from 'react';

const LogoComponent = ({ className }: { className?: string }): JSX.Element => (
  <div className={className}>
    <img src={LogoIn} alt="badge-inside" />
    <img src={LogoOut} alt="badge-outside" />
  </div>
);
export default LogoComponent;
